$(document).on('change', '.rc_widget .rc_widget__option .rc_widget__option__input', function(){
	var $checked = $('.rc_widget .rc_widget__option .rc_widget__option__input:checked'),
	$price = $checked.closest('label').find('.rc-option__price').text();
	$('.product-price-value').text($price);
	var $originalPrice = $('#original_price').val();
	if(!$('.recharge-one-time-price').length) {
		$('.rc-option__subsave .rc-option__price').append('<span class="recharge-one-time-price">' + $originalPrice + '</span>');
	}
	discountedPrice();
	if($checked.closest('.rc-radio').hasClass('rc-option__subsave')) {
		$('.rc-selling-plans').addClass('selling-plan-selected');
		var $originalPrice = parseInt($('.rc-option__onetime .rc-option__price').text().replace(/[,$]/g, "")),
		$discount = 1 - parseInt($('.rc-option__subsave .rc-option__discount').text())/100,
		$discountedPrice = $discount * $originalPrice,
		$discountedPrice = '$' + $discountedPrice.toFixed(2);
		$currentPrice = $discountedPrice;
	} else {
		$('.rc-selling-plans').removeClass('selling-plan-selected');
		$currentPrice = $originalPrice
	}
	var $classes = $('.recharge-inner-most-price').attr('class');
	$('.recharge-inner-most-price').removeAttr('class').html($currentPrice).addClass('temporary-for-update');
	setTimeout(function(){
		$('.temporary-for-update').addClass($classes).removeClass('temporary-for-update');
	}, 500);
});

$(document).on('change', '.rc-selling-plans .rc_widget__option__plans__dropdown', function(){
	var $originalPrice = $('#original_price').val();
	$('.rc-option__onetime .rc_widget__price--onetime').html($originalPrice);
	discountedPrice();
});

$(document).ready(function(){
	var $recharge = $('#recharge_available').val();
	if($recharge) {
		var $interval = setInterval(function(){
			var $widget = $('.rc-container-wrapper');
			if($widget.length) {
				updateWidget();
				clearInterval($interval);
			}
		}, 500);
	}
});

function updateWidget() {
	var $originalPrice = $('.recharge-inner-most-price').text(),
	$discount = $('.rc-option__subsave .rc-option__discount').text(),
	$discountLabel = "Save " + $discount + " on all deliveries";
	$('.rc-option__subsave .rc-option__price').append('<span class="recharge-one-time-price">' + $originalPrice + '</span>');
	$('.rc-option__onetime .rc-option__price').html($originalPrice);
	var $deliveries = [];
	var $loopLength = $('.rc-selling-plans .rc_widget__option__plans__dropdown option').length;
	$deliveryLabel = 'Delivers every ';
	i = 1;
	$('.rc-selling-plans .rc_widget__option__plans__dropdown option').each(function(){
		var $this = $(this),
		$number = $this.text().match(/\d+/);
		if(i == 0) {
			$deliveryLabel += $number;
		} else {
			if(i < $loopLength) {
				$deliveryLabel += $number + ', ';
			} else {
				$deliveryLabel += 'or ' + $number + ' days';
			}
		}
		i++;
	});
	$('.rc-option__subsave').append('<span class="rc-option-custom-labels">' + $discountLabel + '</span><span class="rc-option-custom-labels">' + $deliveryLabel + '</span><span class="rc-option-custom-labels">Skip or cancel anytime with no fees</span>');
	discountedPrice();
}

function discountedPrice(originalprice) {
	var $originalPrice = parseInt($('#original_price').val().replace(/[,$]/g, "")),
	$discount = 1 - parseInt($('.rc-option__subsave .rc-option__discount').text())/100,
	$discountedPrice = $discount * $originalPrice,
	$discountedPrice = '$' + $discountedPrice.toFixed(2);
	$originalPrice = '$' + $originalPrice.toFixed(2);
	$html = $discountedPrice + '<span class="recharge-one-time-price">' + $originalPrice + '</span>';
	$('.rc-option__subsave .rc-option__price').html($html);
}

$(document).on('click', '.add-set-to-cart', function(){
	addToCart();
});

function addToCart() {
	const _timestamp = new Date().getTime();
	var $data = [];
	let productsInBundle = 0; // Cause there is a free bag
	const parentProductJson = JSON.parse($('script#parent-product-json').html());
	let childIds = []
	let childProductNames = []
	$('.main-set-product').each(function(){
		var $this = $(this);
		if($this.find('.set-property').length) {
			$variant = $this.find('.set-property:checked').data('variant-id')
			$variantImage = $this.find('.set-property:checked').data('image');
		} else {
			$variant = $this.data('variant-id')
			$variantImage = $this.data('image');
		}
		const $name = $this.data('name') + '|' + $this.data('type') + '||' + $this.find('.set-property:checked').data('image');
		$data.push({
			"quantity": 1,
			"id": $variant,
			 properties: {
			 	_unique_bundle_id: _timestamp,
			 	"_bundle_product": "Yes",
			 }
		});
		childIds.push($variant)
		childProductNames.push($name)
		productsInBundle++;
	});

	// Find the variant of parent product that suites for number of productsInBundle
	 const parentVariant = $('.add-set-to-cart').data('variant');

	 $data.push({
	 		"quantity": 1,
	 		"id": parentVariant,
	 		properties: {
	 			_unique_bundle_id: _timestamp,
			 	"_bundle_product": "Yes",
	 	}
	 });

	const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	const sections = cart_holder.getSectionsToRender().map((section) => section.id);
	cart_holder.setActiveElement(document.getElementById('CartDrawer'));
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			items: $data,
			sections,
			sections_url: window.location.pathname + (window.location.search || '')
		},
		success: function(response) {
					if(response.status){
						alert(response.description || 'An error has occurred.')
						return;
					}

					if(cart_holder && cart_holder.classList.contains('is-empty')){ cart_holder.classList.remove('is-empty');}
			cart_holder.renderContents(response);
					
		},
		error: function(response, a, b) {
					
					if(response){
						alert(response?.responseJSON?.description || 'An error has occurred.')
						return;
					}
		}
	});
}

$(document).on('change input', '.main-set-product .ms-option-values input', function(){
	var $this = $(this),
	$image = $this.closest('.ms-option-values').find('input:checked').data('image'),
	$target = $this.closest('.main-set-product').find('.ms-image img');
	$target.attr('src', " ");
	$target.attr('src', $image);
});

$(document).ready(function(){
	if($('body').hasClass('template-product-set')) {
		$('.ms-option-values').each(function(){
			var $this = $(this),
			$image = $this.find('input:checked').data('image'),
			$target = $this.closest('.main-set-product').find('.ms-image img');
			$target.attr('src', " ");
			$target.attr('src', $image);
		});
	}
});

$(document).on('click', '.customer-reviews-meta a', function(){
	var $this = $(this),
	$target = $('.' + $this.attr('href')),
	$offset = $target.offset().top;
	$('html, body').animate({
		'scrollTop': $offset
	});
	return false;
});

$(document).on('click', '.accordion-title li:not(.active-accordion) a', function(){
	var $this = $(this),
	$target = $('#' + $this.attr('href')),
	$parent = $this.closest('li');
	$('.active-accordion').removeClass('active-accordion');
	$parent.addClass('active-accordion');
	$('.accordion-content-item').hide();
	$target.show();
	return false;
});

$(document).on('click', '.go-to-full-desc', function(){
	$('.description-accordion a').trigger('click');
	var $offset = $('.description-accordion').offset().top;
	$('html, body').animate({
		'scrollTop':$offset
	});
});

$(document).on('click', '.ui-upsell-title li:not(.active-upsell) a', function(){
	var $this = $(this),
	$target = $($this.attr('href')),
	$parent = $this.closest('li');
	$this.closest('.upsell-content').find('.active-upsell').removeClass('active-upsell');
	$this.closest('.upsell-content').find('.upsell-tab-item').hide();
	$parent.addClass('active-upsell');
	$target.show();
	return false;
});

$(document).on('click', '.view-all-items', function(){
	var $this = $(this);
	if($this.hasClass('view-less-items')) {
		$this.removeClass('view-less-items');
		$this.text('View More');
		$this.closest('.upsell-tab-item').find('.upsell-item:not(:first-of-type)').hide();
	} else {
		$this.addClass('view-less-items');
		$this.text('View Less');
		$this.closest('.upsell-tab-item').find('.upsell-item').css('display', 'grid');
	}
	return false;
});

$(document).on('click', '.full-ing-button', function(){
	$('#modal-full-ing').addClass('is-open');
});

$(document).on('click', '#modal-full-ing .modal__footer button', function(){
	$('#modal-full-ing').removeClass('is-open');
});

$(document).on('click', '.ui-add-cart', function(){
	var $this = $(this),
	$variant = $this.data('variant');
	$this.html('Adding');
	var $data = [];
	$data.push({
		"quantity": 1,
		"id": $variant,
	});
	const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	const sections = cart_holder.getSectionsToRender().map((section) => section.id);
	cart_holder.setActiveElement(document.getElementById('CartDrawer'));
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			items: $data,
			sections,
			sections_url: window.location.pathname + (window.location.search || '')
		},
		success: function(response) {
			if(response.status){
				alert(response.description || 'An error has occurred.')
				return;
			}

			if(cart_holder && cart_holder.classList.contains('is-empty')){ cart_holder.classList.remove('is-empty');}
			cart_holder.renderContents(response);
			$this.html('Added');		
		},
		error: function(response, a, b) {
					
					if(response){
						alert(response?.responseJSON?.description || 'An error has occurred.')
						return;
					}
		}
	});
});

$(document).on('change', '.shade-option-container input', function(){
	var $this = $(this),
	$val = $this.val();
	$('.shade-name').html($val);
});

let swiper;
$(document).on('change', '.shade-option-container input', function(){
	var $this = $(this);
	if ($('.product--stacked').length) {
		var $val = $this.data('value'),
		$target = $(".product--stacked li." + $val);
		if ($target.length) {
			$('.product--stacked li').addClass('slides-hidden');
			$target.removeClass('slides-hidden');
		} else {
			$('.product--stacked li').removeClass('slides-hidden');
		}
		if (!swiper) {
			swiper = new Swiper('.product__media-slider', {
				loop: false,
				slidesPerView: 1,
				spaceBetween: 20,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				scrollbar: {
					el: '.swiper-scrollbar'
				},
			});
		} else {
			swiper.destroy();
			swiper = new Swiper('.product__media-slider', {
				loop: false,
				slidesPerView: 1,
				spaceBetween: 20,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				scrollbar: {
					el: '.swiper-scrollbar'
				},
			});
		}
	}
});
